import { PermissionArrayType } from '../../../types/other';
import { getAllPermissionRolesForUserLevel, PERMISSIONROLECONSTANTS } from '../../../features/utils/utils.action';

export const CDRPermissions: PermissionArrayType = {
  CREATE: [PERMISSIONROLECONSTANTS.superadmin, PERMISSIONROLECONSTANTS.telcloud_admin],
  READ: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud'),
    ...getAllPermissionRolesForUserLevel('reseller'),
    ...getAllPermissionRolesForUserLevel('customer'),
  ],
  UPDATE: [PERMISSIONROLECONSTANTS.superadmin, PERMISSIONROLECONSTANTS.telcloud_admin],
  DELETE: [PERMISSIONROLECONSTANTS.superadmin, PERMISSIONROLECONSTANTS.telcloud_admin],
};
